import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  type Timestamp,
} from "firebase/firestore";

import { db } from "@/config/firebase";
import { firestoreErrorCode } from "@/lib/firestoreErrors";
import { logger } from "@/lib/logger";

import type { Announcement, AnnouncementKind } from "./types";

const ANNOUNCEMENTS = collection(db, "announcements");

export function watchAnnouncements(cb: (items: Announcement[]) => void): () => void {
  const q = query(ANNOUNCEMENTS, orderBy("isPinned", "desc"), orderBy("postedAt", "desc"));
  return onSnapshot(
    q,
    (snap) => {
      const items: Announcement[] = snap.docs.map((d) => {
        const data = d.data() as Omit<Announcement, "id">;
        return { id: d.id, ...data };
      });
      cb(items);
    },
    (err) => {
      logger.warn("announcements subscribe failed", {
        code: firestoreErrorCode(err),
        message: err instanceof Error ? err.message : String(err),
      });
      cb([]);
    },
  );
}

export interface AnnouncementInput {
  kind: AnnouncementKind;
  title: string;
  body: string;
  isPinned: boolean;
  authorName?: string;
}

export async function createAnnouncement(input: AnnouncementInput): Promise<string> {
  const ref = await addDoc(ANNOUNCEMENTS, {
    ...input,
    postedAt: serverTimestamp() as unknown as Timestamp,
  });
  return ref.id;
}

export async function updateAnnouncement(id: string, patch: Partial<AnnouncementInput>): Promise<void> {
  await updateDoc(doc(db, "announcements", id), patch);
}

export async function deleteAnnouncement(id: string): Promise<void> {
  await deleteDoc(doc(db, "announcements", id));
}
